import * as types from "./types";
import { LOGOUT } from "../iam/types";
/*
conversations -> list of conversations
messages: {
    {'convesation_guid': {
        'is_loading'
        'errors'
        'list':[]
        'last_evaluated_key'        
    }}
}
*/

export const defaultState = {
  notifications: [],
  loading: false,
  has_more: false,
  last_evaluated_key: null,
  errors: []
};

const app_notifications = (state = defaultState, action) => {
  switch (action.type) {
    case LOGOUT:
      return defaultState;
    case types.FETCHING_APP_NOTIFICATIONS:
      return {
        ...state,
        loading: action.loading
      };
    case types.FETCHED_APP_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.notifications,
        has_more: action.has_more,
        last_evaluated_key: action.last_evaluated_key,
        loading: action.loading
      };
    case types.ERROR_FETCHING_APP_NOTIFICATIONS:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      };
    default:
      return state;
  }
};
export default app_notifications;
